import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=e2471a86&scoped=true&"
import script from "./CharacterList.vue?vue&type=script&lang=ts&"
export * from "./CharacterList.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterList.vue?vue&type=style&index=0&id=e2471a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2471a86",
  null
  
)

export default component.exports